<script setup lang="ts">
  import { ref, computed } from 'vue';
  import TwoFactorAuthSetup from '@/common/shared/TwoFactorAuthSetup.vue';
  import useAuthStore from '@/common/store/pinia/auth';

  type Props = {
    username?: string;
    pending?: boolean;
  }

  type EmitEvents = {
    (event: 'submit', code: string): void;
    (event: 'cancel'): void
  }

  const props = defineProps<Props>();
  const emit = defineEmits<EmitEvents>();

  const authStore = useAuthStore();
  const setupRef = ref();

  const displayUsername = computed(() => props.username || authStore.currentUser?.name || '');

  const handleSubmit = (code: string) => {
    emit('submit', code);
  };

  const handleCancel = () => {
    emit('cancel');
  };

  defineExpose({
    handleSubmit,
    handleCancel,
    displayUsername,
    setupRef
  });
</script>

<template>
  <div class="two-factor-auth-setup-overlay v-two-factor-auth-setup-form">
    <div class="body-header-title el-text--align-center">
      {{ $t('Configure two-factor authentication') }}
    </div>
    <div class="setup-container">
      <TwoFactorAuthSetup
        ref="setupRef"
        :username="displayUsername"
        :pending="pending"
        @submit="handleSubmit"
        @cancel="handleCancel"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .body-header-title {
    font-size: $av-font-size-l;
    padding: 8px 24px 16px;
  }

  .two-factor-auth-setup-overlay {
    width: 512px;
    padding: 24px;
    margin: 0 auto;
    border-radius: 5px;
    background: $av-inversed-primary;
    position: relative;
  }

  .setup-container {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
</style>
